export default "__VITE_ASSET__cff95992__"